import { useEffect, useState } from 'react';
import { Button, Container, Dialog, Divider, Grid, IconButton, Paper, Stack, Typography,Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag, CheckBox, Checkbox } from '../../../../../components';
import { request, toast } from '../../../../../utils';
import { YES_NO, DISCOUNT_APPLICABLE_ON, APPLICABLE_ON, DISCOUNT_TYPE } from '../../../../../constants';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';

const TABLE_COLUMNS = [
  {
    header: 'Discount Name',
    accessor: 'discount_name'
  },

  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const initialDiscountMasterDataObj = {
  data: [],
  loading: false
};

export const CollectionCenterMaster = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [discountMasterDataObj, setDiscountMasterDataObj] = useState(initialDiscountMasterDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();



  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        discount_name: Yup.string().required('Discount Name Is Required ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('discount_name', selectedRecord.discount_name);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/' : '/', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        discount_name: formValues.discount_name,
        effect_on_doctor_share: formValues.effect_on_doctor_share,
        discount_applicable_on: formValues.discount_applicable_on,
        discount_type: formValues.discount_type,
        discount_percentage: formValues.percentage
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Discount master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Discount master`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Discount master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Discount master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setDiscountMasterDataObj({ loading: true });
    const response = await request('/', { method: 'GET' });
    if (response.success) {
      setDiscountMasterDataObj({ loading: false, data: response.data });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDiscountMasterDataObj({ loading: false });
    }
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3">
                Collection Center Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={"Submit"}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                  onClick={handleSubmit(formSubmit)} // Change here
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={"Cancel"}
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                  Print
                </CustomButtonn>
                <CustomButtonn id={"Exit"} variant="contained">Exit</CustomButtonn>
              </Stack>
            </Stack>
            <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Center Name </Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.5 }}
                    placeholder="Enter Collection Center Name"
                    name="center_name"
                  />
                  <Typography sx={{ flex: 0.1, fontWeight: 700 }}>Barcode Prefix </Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.2 }}
                    placeholder="Enter Collection Center Name"
                    name="center_name"
                  />
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Address1</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    placeholder="Enter Address1"
                    sx={{ flex: 0.8 }}
                    name="address_1"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Address2</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    placeholder="Enter Address2"
                    sx={{ flex: 0.5 }}
                    name="address_2"
                  />
                  <Typography sx={{ flex: 0.1, fontWeight: 700 }}>Ph. No.</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    placeholder="Enter Address2"
                    sx={{ flex: 0.2 }}
                    name="ph_no"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Country Name</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.5 }}
                    name="country"
                  />
                  <Typography sx={{ flex: 0.1, fontWeight: 700 }}>State</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.2 }}
                    name="state"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>City</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.5 }}
                    name="city"
                  />
                  <Typography sx={{ flex: 0.1, fontWeight: 700 }}>Pincode</Typography>
                  <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.2 }} name="pincode" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Mob. No.</Typography>
                  <TextField
                    placeholder="Enter Mobile No."
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.5 }}
                    name="mob_no"
                  />
                  <Typography sx={{ flex: 0.1, fontWeight: 700 }}>Email</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.2 }}
                    placeholder="Enter Email"
                    name="email"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Rate List</Typography>
                  <SelectTag
                    placeholder="Enter Rate List"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.5 }}
                    name="rate_list"
                  />
                  <Typography sx={{ flex: 0.1, fontWeight: 700 }}>Deposit Amount</Typography>
                  <TextField
                    placeholder="Enter Deposit Amount"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.2 }}
                    name="email"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Cr. Days</Typography>
                  <SelectTag
                    placeholder="Enter Credit Limit  Days"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.5 }}
                    name="cr_days"
                  />
                  <Typography sx={{ flex: 0.1, fontWeight: 700 }}>Cr. Amount</Typography>
                  <TextField
                    placeholder="Enter Credit Amount"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.2 }}
                    name="credit_amt"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Checkbox
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.5 }}
                    name="cr_days"
                  />
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Is Daily Center</Typography>
                  <Checkbox
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.5 }}
                    name="discount_applicable"
                  />
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Discount Applicable</Typography>
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>Gen Dis%</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.5 }}
                    name="gen_dis"
                    placeholder="Enter General Discount Per"
                  />
                  <Typography sx={{ flex: 0.2, fontWeight: 700 }}>OS Dis%</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.37 }}
                    name="os_dis"
                    placeholder="Enter Outsource Discount Per"
                  />
                </Stack>
              </Grid>
            </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Discount Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 3 }}
          columns={TABLE_COLUMNS}
          data={discountMasterDataObj.data || []}
          loading={discountMasterDataObj.loading}
          onRowClick={(row) => {
            setOpenQueryDialog(false);
            setSelectedRecord(row);
          }}
        />
      </Dialog>
    </>
  );
};
